/* global FB */
import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'
import { motion } from 'framer-motion'
import {
  CheckBadge,
  Clock,
  FacebookIcon,
  InstagramIcon,
  KeyRed,
  LinkedinIcon,
  LockClosed,
  //PinterestIcon,
  TikTokIcon,
  TwiterIcon,
} from '../../../../assets/svgs/icons'
import { useNavigate } from 'react-router-dom'

import key_red from '../../../../assets/icons/svg/key_red.svg'

import {
  LinkedinService,
  UserAccountsService,
  TwitterService,
  SocialMediaConnectionService,
  PlanService,
  SubscriptionService,
  TiktokService,
  MetaService,
} from '../../../../services'
import {
  getBusinessByClientId,
  getBusinessByLogin,
} from '../../../../services/business'
import { useClient } from '../../../../hooks/useClient'
// import { useLocalStorage } from '../../../../hooks/useLocalStorage'
import { useRedirect } from '../../../../hooks/useRedirectPAge'
import { useTranslation } from 'react-i18next'
import Loading from '../../../../components/Loading'
import { notifyWarningCustom } from '../../../../utils/notify'
import { launchInstagramOAuthRedirect } from '../../../../shared/campaign/utils/instagramOAuthRedirect'
import {
  getCurrentReturnPath,
  resolveInstagramOAuthReturnPage,
} from '../../../../shared/campaign/utils/instagramOAuth'
import { useInstagramOAuthReturn } from '../../../../shared/campaign/hooks/useInstagramOAuthReturn'

export const SocialMedia = () => {
  const { t } = useTranslation()
  const [settingsCompleted, setSettingsCompleted] = useState({
    parameterizationCompleted: true,
  })
  const { clientData } = useClient()


  const { setRedirect } = useRedirect()

  const [tokenSocialMedia, setTokenSocialMedia] = useState('')
  const [profileNameLinkedin, setProfileNameLinkedin] = useState('')
  const [profileNameTwitter, setProfileNameTwitter] = useState('')
  const [profileNameInstagram, setProfileNameInstagram] = useState('')
  const [profileNameFacebook, setProfileNameFacebook] = useState('')
  const [profileTiktok, setProfileTiktok] = useState('')

  const [isLoading, setIsLoading] = useState(false)

  const initFacebookSDK = () => {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '387543906967686',
        cookie: true,
        xfbml: true,
        version: 'v20.0',
      })

      FB.AppEvents.logPageView()
    }
    ;(function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }

  // const handleNavigate = () => {
  //   if (settingsCompleted?.parameterizationCompleted) {
  //     navigate('/StepsPage')
  //   } else {
  //     navigate('/StepsPage', {
  //       state: { uncompletedSteps: settingsCompleted?.uncompletedSteps },
  //     })
  //   }
  // }

  useEffect(() => {
    // setTokenLinkedin(localStorage.getItem('tokenLinkedin'))
    loadData()
    loadConnectionSocialMedia()
  }, [clientData])

  useEffect(() => {
    initFacebookSDK()
  }, [])

  const loadConnectionSocialMedia = async () => {
    let businessId
    if (clientData?.uuid) {
      const { data } = await getBusinessByClientId(clientData?.uuid)
      businessId = data[0]?.uuid
    } else {
      const { data } = await getBusinessByLogin()

      businessId = data[0].uuid
    }

    const { data } =
      await SocialMediaConnectionService.getSocialMediaConnections(businessId)

    if (data.linkedin) {
      const retLinkedin =
        await SocialMediaConnectionService.getSocialMediaByBusinessAndSocialType(
          businessId,
          1
        )
      setProfileNameLinkedin(retLinkedin.data.profileName)
    }
    if (data.twitter) {
      const retTwitter =
        await SocialMediaConnectionService.getSocialMediaByBusinessAndSocialType(
          businessId,
          2
        )
      setProfileNameTwitter(retTwitter.data.profileName)
    }

    if (data.tiktok) {
      const retTiktok =
        await SocialMediaConnectionService.getSocialMediaByBusinessAndSocialType(
          businessId,
          3
        )

      setProfileTiktok(retTiktok.data.profileName)
    }

    if (data.instagram) {
      const retInstagram =
        await SocialMediaConnectionService.getSocialMediaByBusinessAndSocialType(
          businessId,
          4
        )

      setProfileNameInstagram(retInstagram.data.profileName)
    }

    if (data.facebook) {
      const retFacebook =
        await SocialMediaConnectionService.getSocialMediaByBusinessAndSocialType(
          businessId,
          5
        )

      setProfileNameFacebook(retFacebook.data.profileName)
    }

    setTokenSocialMedia(data)
  }

  useInstagramOAuthReturn({
    onSuccess: () => loadConnectionSocialMedia(),
    onFailure: () => {
      notifyWarningCustom(
        t('chatsocket.social_media.errors.instagram_oauth_incomplete'),
      )
    },
  })

  const loadData = async () => {
    const { data, status } =
      await UserAccountsService.getUserAccountsParameterizationCompleted()

    if (status === 200) {
      setSettingsCompleted(data)
    }
  }

  // const handleRedirect = (url, id) => {
  //   setRedirect(url, id) // Substitua '123' pelo ID real que você deseja passar
  // }

  // const navigation = useNavigate()

  const SocialMediaLogin = async (item, event) => {
    setIsLoading(true)

    if (event) {
      event.preventDefault() // Previne o comportamento padrão de refresh
    }
    let socialCount

    if (clientData?.uuid) {
      socialCount =
        await SocialMediaConnectionService.getAllSocialMediaConnectionBusinessClientCount(
          clientData?.uuid
        )
    } else {
      socialCount =
        await SocialMediaConnectionService.getAllSocialMediaConnectionUserCount()
    }

    // const userSubscription = await SubscriptionService.getSubscriptionByUser();

    // if (userSubscription.data.length <= 0 && socialCount.data.length >= 2) {
    //   notifyWarningCustom(t("social_media.limit_message"));
    // } else if (userSubscription.data.length > 0) {
    //   const index = await userSubscription.data[0].Plan.PlanItems.findIndex(
    //     (item) => item.type === "integration_quantity"
    //   );
    //   const quantityItemSocial =
    //     userSubscription.data[0].Plan.PlanItems[index]?.quantity;
    //   if (socialCount.data.length >= quantityItemSocial) {
    //     notifyWarningCustom(t("social_media.limit_message"));
    //     return;
    //   }
    // }

    let businessId

    if (clientData?.uuid) {
      const { data } = await getBusinessByClientId(clientData?.uuid)
      businessId = data[0]?.uuid
    } else {
      const { data } = await getBusinessByLogin()
      businessId = data[0].uuid
    }

    if (item === 'tiktok') {
      const data = await TiktokService.getTiktokLoginByBusiness(businessId)

      setRedirect('/MyAccountPage', clientData)
      window.location.href = data.dataT
    }

    if (item === 'linkedin') {
      const { dataL } = await LinkedinService.getLinkedinByBusiness(businessId)
      setRedirect('/MyAccountPage', clientData)
      window.location.href = dataL
    }

    if (item === 'instagram') {
      launchInstagramOAuthRedirect({
        businessId,
        returnPage: resolveInstagramOAuthReturnPage('/MyAccountPage'),
        returnPath: getCurrentReturnPath(),
      })
    }

    if (item === 'twitter') {
      const { dataT, responseStatusT } =
        await TwitterService.getTwitterByBusiness(businessId)

      if (responseStatusT != 200 || responseStatusT != 204) {
        // console.log('Erro', responseStatusT)
      }

      setRedirect('/MyAccountPage', clientData)
      window.location.href = dataT
    }

    if (item === 'facebook') {
      const data = await MetaService.getFacebookLoginByBusiness(businessId)

      setRedirect('/MyAccountPage', clientData)
      window.location.href = data.dataT
    }

    setIsLoading(false)
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={styles.page}
    >
      <Loading enable={isLoading} />

      <div className={styles.container_social_media}>
        <div className={styles.box_parameterization_content}>
          <div className={styles.social_media_module}>
            <div className={styles.module}>
              <h3 className={styles.module_title}>{t('social_media.title')}</h3>
            </div>
          </div>
          <div className={styles.container_social_media_content}>
            <div className={styles.card}>
              <div className={styles.icon_field}>
                <InstagramIcon />
              </div>
              <div style={{ width: '100%' }}>
                <p
                  style={{
                    margin: 0,
                    color: '#3E3E3E',
                    fontSize: 8,
                    fontweight: 300,
                  }}
                >
                  {t('social_media.status')}
                </p>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                  }}
                >
                  {!tokenSocialMedia?.instagram ? (
                    <>
                      <p
                        style={{
                          margin: 0,
                          fontSize: 12,
                          fontWeight: 500,
                          color: '#FF2F00',
                        }}
                      >
                        {t('social_media.not_connected')}
                      </p>

                      <img
                        src={key_red}
                        alt="key_red"
                        style={{ height: 15 }}
                        //onContextMenu={(e) => e.preventDefault()}
                      />
                    </>
                  ) : (
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#0FBE00',
                      }}
                    >
                      {t('social_media.connected_as')}: {profileNameInstagram}
                    </p>
                  )}
                  <KeyRed />
                </div>
              </div>
              <div onClick={() => SocialMediaLogin('instagram')}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 32,
                    gap: 8,
                    border: '1px solid #6A0098',
                    borderRadius: 6,
                    padding: '4px 10px',
                    cursor: 'pointer',
                  }}
                >
                  <p
                    style={{ fontSize: 12, fontWeight: 500, color: '#190027' }}
                  >
                    {t('social_media.login')}
                  </p>
                  {/* <img src={lock_closed} alt="key_red" style={{ height: 20 }} /> */}
                  <LockClosed />
                </div>
              </div>
            </div>

            {/* Facebook Card */}
            <div className={styles.card}>
              <div className={styles.icon_field}>
                <FacebookIcon />
              </div>
              <div style={{ width: '100%' }}>
                <p
                  style={{
                    margin: 0,
                    color: '#3E3E3E',
                    fontSize: 8,
                    fontweight: 300,
                  }}
                >
                  {t('social_media.status')}
                </p>
                {!tokenSocialMedia?.facebook ? (
                  <>
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#FF2F00',
                      }}
                    >
                      {t('social_media.not_connected')}{' '}
                      <img
                        src={key_red}
                        alt="key_red"
                        style={{ height: 15 }}
                      />
                    </p>
                  </>
                ) : (
                  <p
                    style={{
                      margin: 0,
                      fontSize: 12,
                      fontWeight: 500,
                      color: '#0FBE00',
                    }}
                  >
                    {t('social_media.connected_as')}: {profileNameFacebook}
                  </p>
                )}
              </div>
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 32,
                    gap: 8,
                    border: '1px solid #6A0098',
                    borderRadius: 6,
                    padding: '4px 10px',
                    cursor: 'pointer',
                  }}
                  onClick={() => SocialMediaLogin('facebook')}
                >
                  <p
                    style={{ fontSize: 12, fontWeight: 500, color: '#190027' }}
                  >
                    {t('social_media.login')}
                  </p>

                  <LockClosed />
                </div>
              </div>
            </div>

            {/* Pinterest */}
            {/* <div className={styles.card}>
              <div className={styles.icon_field}>
                <PinterestIcon />
              </div>
              <div style={{ width: '100%' }}>
                <p
                  style={{
                    margin: 0,
                    color: '#3E3E3E',
                    fontSize: 8,
                    fontweight: 300,
                  }}
                >
                  {t('social_media.status')}
                </p>
                {
                  // item.connected ? (
                  //   <div
                  //     style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                  //   >
                  //     <p
                  //       style={{
                  //         margin: 0,
                  //         fontSize: 12,
                  //         fontWeight: 500,
                  //         color: '#0FBE00',
                  //       }}
                  //     >
                  //       Conectado como: posteiapp
                  //     </p>
                  //   </div>
                  // ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#FF2F00',
                      }}
                    >
                      {t('social_media.not_connected')}
                    </p>
                    <img src={key_red} alt="key_red" style={{ height: 15 }} />
                    <KeyRed />
                  </div>
                  // )
                }
              </div>
              <div
              //onClick={() => SocialMediaLogin(item)}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 32,
                    gap: 8,
                    border: '1px solid #6A0098',
                    borderRadius: 6,
                    padding: '4px 10px',
                    cursor: 'pointer',
                  }}
                >
                  <p
                    style={{ fontSize: 12, fontWeight: 500, color: '#190027' }}
                  >
                    {t('social_media.login')}
                  </p>
                  
                  <LockClosed />
                </div>
              </div>
            </div> */}

            {/* Linkeddin */}
            <div className={styles.card}>
              <div className={styles.icon_field}>
                <LinkedinIcon />
              </div>
              <div style={{ width: '100%' }}>
                <p
                  style={{
                    margin: 0,
                    color: '#3E3E3E',
                    fontSize: 8,
                    fontweight: 300,
                  }}
                >
                  {t('social_media.status')}
                </p>
                {
                  // item.connected ? (
                  //   <div
                  //     style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                  //   >
                  //     <p
                  //       style={{
                  //         margin: 0,
                  //         fontSize: 12,
                  //         fontWeight: 500,
                  //         color: '#0FBE00',
                  //       }}
                  //     >
                  //       Conectado como: posteiapp
                  //     </p>
                  //   </div>
                  // ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    {!tokenSocialMedia?.linkedin ? (
                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: 12,
                            fontWeight: 500,
                            color: '#FF2F00',
                          }}
                        >
                          {t('social_media.not_connected')}
                        </p>

                        <img
                          src={key_red}
                          alt="key_red"
                          style={{ height: 15 }}
                          //onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    ) : (
                      <p
                        style={{
                          margin: 0,
                          fontSize: 12,
                          fontWeight: 500,
                          color: '#0FBE00',
                        }}
                      >
                        {t('social_media.connected_as')}: {profileNameLinkedin}
                      </p>
                    )}
                    <KeyRed />
                  </div>

                  // )
                }
              </div>
              <div onClick={() => SocialMediaLogin('linkedin')}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 32,
                    gap: 8,
                    border: '1px solid #6A0098',
                    borderRadius: 6,
                    padding: '4px 10px',
                    cursor: 'pointer',
                  }}
                >
                  <p
                    style={{ fontSize: 12, fontWeight: 500, color: '#190027' }}
                  >
                    {t('social_media.login')}
                  </p>
                  {/* <img src={lock_closed} alt="key_red" style={{ height: 20 }} /> */}
                  <LockClosed />
                </div>
              </div>
            </div>

            {/* TikTok Card */}
            <div className={styles.card}>
              <div className={styles.icon_field}>
                <TikTokIcon />
              </div>
              <div style={{ width: '100%' }}>
                <p
                  style={{
                    margin: 0,
                    color: '#3E3E3E',
                    fontSize: 8,
                    fontweight: 300,
                  }}
                >
                  {t('social_media.status')}
                </p>
                {tokenSocialMedia?.tiktok ? (
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#0FBE00',
                      }}
                    >
                      {t('social_media.connected_as')}: {profileTiktok}
                    </p>
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#FF2F00',
                      }}
                    >
                      {t('social_media.not_connected')}
                    </p>
                    <img
                      src={key_red}
                      alt="key_red"
                      style={{ height: 15 }}
                    />
                    <KeyRed />
                  </div>
                )}
              </div>
              <div onClick={() => SocialMediaLogin('tiktok')}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 32,
                    gap: 8,
                    border: '1px solid #6A0098',
                    borderRadius: 6,
                    padding: '4px 10px',
                    cursor: 'pointer',
                  }}
                >
                  <p
                    style={{ fontSize: 12, fontWeight: 500, color: '#190027' }}
                  >
                    {t('social_media.login')}
                  </p>
                  <LockClosed />
                </div>
              </div>
            </div>

            <div className={styles.card}>
              <div className={styles.icon_field}>
                <TwiterIcon />
              </div>
              <div style={{ width: '100%' }}>
                <p
                  style={{
                    margin: 0,
                    color: '#3E3E3E',
                    fontSize: 8,
                    fontweight: 300,
                  }}
                >
                  {t('social_media.status')}
                </p>
                {tokenSocialMedia?.twitter ? (
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#0FBE00',
                      }}
                    >
                      {t('social_media.connected_as')}: {profileNameTwitter}
                    </p>
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#FF2F00',
                      }}
                    >
                      {t('social_media.not_connected')}
                    </p>
                    <img
                      src={key_red}
                      alt="key_red"
                      style={{ height: 15 }}
                      //onContextMenu={(e) => e.preventDefault()}
                    />
                    <KeyRed />
                  </div>
                )}
              </div>
              <div onClick={() => SocialMediaLogin('twitter')}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 32,
                    gap: 8,
                    border: '1px solid #6A0098',
                    borderRadius: 6,
                    padding: '4px 10px',
                    cursor: 'pointer',
                  }}
                >
                  <p
                    style={{ fontSize: 12, fontWeight: 500, color: '#190027' }}
                  >
                    {t('social_media.login')}
                  </p>

                  <LockClosed />
                </div>
              </div>
            </div>

            {/* <div
              className="fb-login-button"
              data-width=""
              data-size=""
              data-button-type=""
              data-layout=""
              data-auto-logout-link="false"
              data-use-continue-as="true"
            >
              robson
            </div> */}
          </div>
        </div>
      </div>
    </motion.div>
  )
}
